module.exports = __webpack_public_path__ + "static/media/nima_shoe_look.9ede6395.png";